import { APP_CONSTANTS } from 'src/app/constants/constants';
import { DatePipe } from '@angular/common';
import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { CommonService } from 'src/app/services/common/common.service';

@Component({
	selector: 'app-lead-profile',
	templateUrl: './lead-profile.component.html',
	styleUrls: ['./lead-profile.component.scss']
})
export class LeadProfileComponent implements OnInit {
  APP_CONSTANTS = APP_CONSTANTS;

	@Input() data: any;
	@Output() profileClosed = new EventEmitter<any>();

	constructor(
		public commonService: CommonService,
		private datePipe: DatePipe,
	) { }

	ngOnInit(): void {
		this.changeTab(this.profile_tabs[0]);
		this.getProfileData();
	}

	profile_data: any;
	profile_data_loaded: boolean = false;
	getProfileData() {
		this.profile_data_loaded = false;
    if (this.data.business_area_opportunity == 'Deposit Growth'){
      this.commonService.getData('/deposits/prospectdetails/?id=' + this.data.id + '&type='+this.data.type).subscribe(
        (res: any) => {
          this.profile_data = res["data"];
          this.profile_data_loaded = true;
        },
        (err) => {
          this.commonService.showToast('error', err.error);
        },
        )
    } else {
      this.commonService.getData('/prospectdetails/?id=' + this.data.id + '&type='+this.data.type).subscribe(
        (res: any) => {
          this.profile_data = res["data"];
          this.profile_data_loaded = true;
        },
        (err) => {
          this.commonService.showToast('error', err.error);
        },
        );
    }

	}

	close() {
		this.profileClosed.emit("Closed");
	}


	profile_fields_data: any = [
		{
			name: "Personal Information",
			fields: [
				{
					name: "Date of Birth",
					key: "birth_date",
					type: "date"
				},
				{
					name: "Gender",
					key: "gender",
					type: "text"
				},
				{
					name: "Occupation",
					key: "occupation",
					type: "text"
				},
				{
					name: "Education",
					key: "education",
					type: "text"
				},
				{
					name: "Experience(Years)",
					key: "years_experience",
					type: "text"
				},
				{
					name: "Marital Status",
					key: "maritial_status",
					type: "text"
				},
				{
					name: "Individual Income(" + APP_CONSTANTS.CURRENCY_SYMBOL + ")",
					key: "individual_income_in_dollars",
					type: "text"
				},
			]
		},
		{
			name: "Contact Information",
			fields: [
				{
					name: "Email ID",
					key: "email",
					type: "text"
				},
				{
					name: "Phone Number",
					key: "telephone_number",
					type: "text"
				},
			]
		},
		{
			name: "Primary Address Information",
			fields: [
				{
					name: "Address Line 1",
					key: "address_line_1",
					type: "text"
				},
				{
					name: "Address Line 2",
					key: "address_line_2",
					type: "text"
				},
				{
					name: "City",
					key: "city",
					type: "text"
				},
				{
					name: "State",
					key: "state",
					type: "text"
				},
				{
					name: "Zip Code",
					key: "zip_code",
					type: "text"
				},
				{
					name: "Region",
					key: "region",
					type: "text"
				},
				{
					name: "Residence Type",
					key: "homeowner_or_renter",
					type: "text"
				},
				{
					name: "Years in Residence (Years)",
					key: "years_in_residence",
					type: "text"
				},
			]
		},
		{
			name: "Address 2 Information",
			fields: [
				{
					name: "Address Line 1",
					key: "address_2_line_1",
					type: "text"
				},
				{
					name: "Address Line 2",
					key: "address_2_line_2",
					type: "text"
				},
				{
					name: "City",
					key: "address_2_city",
					type: "text"
				},
				{
					name: "State",
					key: "address_2_state",
					type: "text"
				},
				{
					name: "Zip Code",
					key: "address_2_zip_code",
					type: "text"
				},
				{
					name: "Region",
					key: "address_2_region",
					type: "text"
				},
				{
					name: "Residence Type",
					key: "address_2_homeowner_or_renter",
					type: "text"
				},
				{
					name: "Years in Residence (Years)",
					key: "address_2_years_in_residence",
					type: "text"
				},
			]
		},
		{
			name: "Address 3 Information",
			fields: [
				{
					name: "Address Line 1",
					key: "address_3_line_1",
					type: "text"
				},
				{
					name: "Address Line 2",
					key: "address_3_line_2",
					type: "text"
				},
				{
					name: "City",
					key: "address_3_city",
					type: "text"
				},
				{
					name: "State",
					key: "address_3_state",
					type: "text"
				},
				{
					name: "Zip Code",
					key: "address_3_zip_code",
					type: "text"
				},
				{
					name: "Region",
					key: "address_3_region",
					type: "text"
				},
				{
					name: "Residence Type",
					key: "address_3_homeowner_or_renter",
					type: "text"
				},
				{
					name: "Years in Residence (Years)",
					key: "address_3_years_in_residence",
					type: "text"
				},
			]
		},
		{
			name: "HouseHold & Behavioural Information",
			fields: [
				{
					name: "Household ID",
					key: "household_id",
					type: "text"
				},
				{
					name: "Is Primary Contact",
					key: "is_primary_contact",
					// type: "boolean",
					type: "text"
				},
				{
					name: "Primary Contact Name",
					key: "household_primary_contact_name",
					type: "text"
				},
				{
					name: "Adults in Household",
					key: "adults_in_household",
					type: "text"
				},
				{
					name: "Children in Household",
					key: "children_in_household",
					type: "text"
				},
				{
					name: "Household Income(" + APP_CONSTANTS.CURRENCY_SYMBOL + ")",
					key: "household_income_in_dollars",
					type: "text"
				},
				{
					name: "Real Estate Investor",
					key: "real_estate_investor",
					type: "boolean"
				},
				{
					name: "Premium Credit Card Holder",
					key: "premium_credit_card_holder",
					type: "boolean"
				},
				{
					name: "Heavy Transactor",
					key: "heavy_transactor",
					type: "text"
				},
			]
		},
		{
			name: "Other Information",
			fields: [
				{
					name: "Vehicle Count",
					key: "vehicle_count",
					type: "text"
				},
				{
					name: "Vehicle Type",
					key: "vehicle_type",
					type: "text"
				},
				{
					name: "Property Type",
					key: "property_type",
					type: "text"
				},
				{
					name: "Home Equity(" + APP_CONSTANTS.CURRENCY_SYMBOL + ")",
					key: "home_equity_available_for_mortgage_in_dollars",
					type: "text"
				},
				{
					name: "Loan to Value(%)",
					key: "loan_to_value_in_percentage",
					type: "text"
				},
				{
					name: "Market Value(" + APP_CONSTANTS.CURRENCY_SYMBOL + ")",
					key: "market_value_of_home_in_dollars",
					type: "text"
				},
				{
					name: "Liquid Net Worth(" + APP_CONSTANTS.CURRENCY_SYMBOL + ")",
					key: "net_worth",
					type: "text"
				},
				{
					name: "Total Net Worth(" + APP_CONSTANTS.CURRENCY_SYMBOL + ")",
					key: "total_networth",
					type: "text"
				},
				{
					name: "Data Source",
					key: "source_type_name",
					type: "text"
				},
				{
					name: "Provider",
					key: "source_name",
					type: "text"
				},
				{
					name: "Referrer",
					key: "source",
					type: "text"
				},
				{
					name: "Last Date of Contact",
					key: "last_date_of_contact",
					type: "date"
				},
				{
					name: "Business Plan",
					key: "business_plan_name",
					type: "text"
				},
			]
		}
	];

	profile_tabs: any = [
		{
			name: "Demographic Info",
		},
		// {
		// 	name: "Existing Products",
		// },
		{
			// name: "Existing Engagements",
			name: "Opportunities",
		},
    	{
			name: "Trusted Contacts",
		},
	];
	profile_tab_selected: any = "";
	changeTab(data) {
		this.profile_tab_selected = data.name;
	}

	getValue(data, key) {
		if (data.type == "text") {
			if (this.profile_data[key] != "" && this.profile_data[key] != null) {
				return this.profile_data[key];
			} else {
				return "-";
			}
		} else if (data.type == "boolean") {
			if (this.profile_data[key] && this.profile_data[key] == true) {
				return "Yes";
			} else {
				return "No";
			}
		} else if (data.type == "date") {
			if (this.profile_data[key] != "" && this.profile_data[key] != null) {
				return this.datePipe.transform(this.profile_data[key], 'dd MMM yyyy');
			} else {
				return "-";
			}
		}
	}

	navigateToExternalLink(link) {
		if (link != "" && link != null) {
			window.open(link, "_blank");
		}
	}


}
